<div class="transfer-success-details rounded-md">
  <div [ngSwitch]="orderFulfillmentStatus">
    <ng-container *ngSwitchCase="OrderItemStatus.Fulfilled">
      <div class="redeem-amount-container">
        <ng-container *ngIf="hasDiscount; else noDiscount">
          <div class="redeem-amount my-0">
            <span class="sr-only">{{
              'promocode.discounted_transfer_amount.aria_label'
                | translate
                  : {
                      value: redeemAmountString(pointsTransferOrder.pointsPaid)
                    }
            }}</span>
            <span aria-hidden="true">
              {{
                'transfer_v2.success.redeem_amount'
                  | translate
                    : redeemAmountParams(pointsTransferOrder.pointsPaid)
              }}
            </span>
          </div>

          <div class="my-0 text-sm text-[#747678] line-through">
            <span class="sr-only">{{
              'promocode.original_transfer_amount.aria_label'
                | translate
                  : {
                      value: redeemAmountString(
                        pointsTransferOrder.pointsAmount
                      )
                    }
            }}</span>
            <span aria-hidden="true">
              {{
                'transfer_v2.success.redeem_amount'
                  | translate
                    : redeemAmountParams(pointsTransferOrder.pointsAmount)
              }}
            </span>
          </div>

          <div
            class="text-[14px] font-semibold text-[#008A02]"
            tabindex="0"
            [attr.aria-label]="
              'promocode.code.aria_label'
                | translate: { value: pointsTransferOrderItemData.promoCode }
            ">
            <rd-shared-icon
              class="mr-2 inline-block h-4 w-4 align-middle"
              iconSymbol="icon-promocode"
              iconTheme="primary"></rd-shared-icon>
            <span aria-hidden="true" class="align-middle">
              {{ pointsTransferOrderItemData.promoCode }}
            </span>
          </div>
        </ng-container>
        <ng-template #noDiscount>
          <div
            class="redeem-amount my-0"
            [attr.aria-label]="
              'transfer_v2.success.redeem_amount'
                | translate: redeemAmountParams(pointsTransferOrder.pointsPaid)
            ">
            <span aria-hidden="true">
              {{
                'transfer_v2.success.redeem_amount'
                  | translate
                    : redeemAmountParams(pointsTransferOrder.pointsPaid)
              }}
            </span>
          </div>
        </ng-template>
      </div>
      <div
        *ngIf="loyaltyProgramImageUrl()"
        class="loyalty-program-image-container">
        <div class="loyalty-program-image-wrapper">
          <img
            class="loyalty-program-image content"
            [src]="brandIconUrl"
            alt="" />
        </div>
        <rd-shared-icon
          class="transfer-icon"
          [iconSymbol]="'icon-icn-transfer'"
          [iconTheme]="'link'"
          [iconOptions]="flippableIconOptions"></rd-shared-icon>

        <div class="loyalty-program-image-wrapper">
          <img
            class="loyalty-program-image content"
            [src]="loyaltyProgramImageUrl()"
            alt="" />
        </div>
      </div>

      <div class="membership-information">
        <rd-shared-dynamic-list
          [items]="pointsTransferDetails"></rd-shared-dynamic-list>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="OrderItemStatus.Failed">
      <p
        class="refunded-message"
        [innerHTML]="
          'transfer_v2.success.refunded_message'
            | translate: refundedMessageParams()
        "></p>
    </ng-container>
  </div>
</div>
